// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3D90z","name":"style_name__2K7aF"};